export default "__VITE_ASSET__D34qUCBX__"